import http from '@/service/http'

const fetchOne = async (context, url) => {
  const response = await http.get(url)
  if (response !== null) {
    return Promise.resolve(response.data.data)
  }
}

const fetch = async ({ commit }, {url, action}) => {
  const response = await http.get(url)
  if (response !== null) {
    commit(action, response.data.data)
    return Promise.resolve(response.data.data)
  }
}

const save = async (context, obj) => {
  const { verb, url, entity } = obj
  const response = await http[verb](url, entity)

  if (response !== null) {
    return Promise.resolve(response.data.data)
  }
}

const update = ({ commit, state }, {mutation, obj}) => {
  commit(mutation, obj)
}

const remove = async (context, url) => {
  const response = await http.delete(url)
  if (response !== null) {
    return Promise.resolve(response.data.data)
  }
}

const setDadosBasicos = ({ commit, state }, obj) => {
  commit('SET_DADOS_BASICOS', obj)
}
const setDescricao = ({ commit, state }, obj) => {
  commit('SET_DESCRICAO', obj)
}
const setLinguaList = ({ commit, state }, obj) => {
  commit('SET_LINGUA_LIST', obj)
}
const setHabilidadeList = ({ commit, state }, obj) => {
  commit('SET_HABILIDADE_LIST', obj)
}
const setCertificacaoList = ({ commit, state }, obj) => {
  commit('SET_CERTIFICACAO_LIST', obj)
}
const setFormacaoAcademicaList = ({ commit, state }, obj) => {
  commit('SET_FORMACAO_ACADEMICA_LIST', obj)
}
const setHistoricoProfissionalList = ({ commit, state }, obj) => {
  commit('SET_HISTORICO_PROFISSIONAL_LIST', obj)
}
const setCategoriaList = ({ commit, state }, obj) => {
  commit('SET_CATEGORIA_LIST', obj)
}
const reset = ({ commit, state }) => {
  commit('SET_CATEGORIA_LIST', [])
  commit('SET_DADOS_BASICOS', {})
  commit('SET_DESCRICAO', {})
  commit('SET_LINGUA_LIST', [])
  commit('SET_HABILIDADE_LIST', [])
  commit('SET_FORMACAO_ACADEMICA_LIST', [])
  commit('SET_CERTIFICACAO_LIST', [])
  commit('SET_HISTORICO_PROFISSIONAL_LIST', [])
}

export default {
  fetch,
  fetchOne,
  save,
  update,
  reset,
  remove,
  setDadosBasicos,
  setDescricao,
  setLinguaList,
  setHabilidadeList,
  setCertificacaoList,
  setFormacaoAcademicaList,
  setHistoricoProfissionalList,
  setCategoriaList
}



// WEBPACK FOOTER //
// ./src/features/vp/curriculo/meusCurriculos/store/actions.js